import React from 'react'
import Img3 from '../../assets/person.jpg'
import './style.css'

// import Swiper core and required modules
import { Pagination } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';


const Testimonials = () => {
  return (
    <section id='testimonials'>
      <h5>Review from clients</h5>
      <h2>Testimonials</h2>

      <Swiper className='container testimonials_container'
        modules={[Pagination]} spaceBetween={40}
        slidesPerView={1}
        pagination={{ clickable: true }} >

        <SwiperSlide className='testimonials'>
          <div className='client_avatar'>
            <img src={Img3} alt='Avatar One' />
          </div>
          <h5 className='client_name'>Jennifer Marcheterre</h5>
          <small className='client_review'>
            "It was a pleasure to collaborate with Thu Mai when she was part of the developers team that helped converting my Flash games in JavaScript (using our PixiJS framework) through the Red River College ACE Project. She always brought a positive attitude in the meetings, asked the right questions and showed how reliable and responsible a team player can be. As a woman pursuing a STEM career, Thu Mai is inspiring, driven and would be a great asset to your team."
          </small>
        </SwiperSlide>
      </Swiper>
    </section>
  )
}

export default Testimonials